import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounce } from 'rxjs/operators';
import { interval } from 'rxjs';
import { Address } from '@kion/data-models';

@Component({
  selector: 'kion-sign-up-shop',
  templateUrl: './sign-up-shop.component.html',
  styleUrls: ['./sign-up-shop.component.scss']
})
export class SignUpShopComponent implements OnInit {

  @Input() titleOptions: {key: string, value: string}[];
  @Input() isoCode: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() email: string;

  @Output('addressChanged') addressChangedEmitter: EventEmitter<Partial<Address>> = new EventEmitter<Partial<Address>>();

  form: FormGroup;

  constructor(formBuilder: FormBuilder) {
    this.form = formBuilder.group(
      {
        salutation: new FormControl("", []),
        company: new FormControl(null, [Validators.minLength(1), Validators.maxLength(50)]),
        vatId: new FormControl(null),
        customerNumber: new FormControl(null),
        address: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
        additionalAddress: new FormControl(null, [Validators.minLength(1), Validators.maxLength(100)]),
        zipCode: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(10)]),
        city: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(60)]),
        phone: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(25)]),
        mobile: new FormControl(null, [Validators.minLength(1), Validators.maxLength(25)])
      }
    )
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(debounce(() => interval(1000)))
      .subscribe(
        values =>  {
          if (this.form.valid) {
            const address = {
              titleCode: values.salutation,
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              companyName: values.company,
              vatId: values.vatId,
              customerId: values.customerNumber,
              line1: values.address,
              line2: values.additionalAddress,
              postalCode: values.zipCode,
              town: values.city,
              phone: values.phone,
              cellphone: values.mobile,
              country: {
                name: "",
                isocode: this.isoCode
              }
            };
            if (this.form.touched || this.form.dirty) {
              this.addressChangedEmitter.emit(address);
            }
          }
        }
      );
  }

  get salutationField() {
    return this.form.get('salutation');
  }
  get companyField() {
    return this.form.get('company');
  }
  get vatIdField() {
    return this.form.get('vatId');
  }
  get customerNumberField() {
    return this.form.get('customerNumber');
  }
  get addressField() {
    return this.form.get('address');
  }
  get additionalAddressField() {
    return this.form.get('additionalAddress');
  }
  get zipCodeField() {
    return this.form.get('zipCode');
  }
  get cityField() {
    return this.form.get('city');
  }
  get phoneField() {
    return this.form.get('phone');
  }
  get mobileField() {
    return this.form.get('mobile');
  }
}
